import { render, staticRenderFns } from "./RealTimeStats.vue?vue&type=template&id=376092d9&scoped=true"
import script from "./RealTimeStats.vue?vue&type=script&lang=js"
export * from "./RealTimeStats.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "376092d9",
  null
  
)

export default component.exports